import { EPosition, StoreBodyBlock } from 'constants/enums';
import { z } from 'zod';

import { GradientDirection } from 'components/AcGradientInput/AcGraidentInput.types';
import {
  ETemplateStudioBundlesViewModel,
  ETemplateStudioLayoutOptions,
  EThemes
} from 'components/TemplatesStudio/enums';

const gradientSchema = z.object({
  colorOne: z.string().min(1, { message: 'Color is required.' }),
  colorTwo: z.string().optional(),
  gradientDirection: z.nativeEnum(GradientDirection).optional()
});

export const templateStudioSchema = z.object({
  templateName: z.string().min(1, { message: 'This field is required.' }),
  description: z.string(),
  tags: z.array(z.string()),
  bodyBlocksOrder: z.array(z.nativeEnum(StoreBodyBlock)),
  header: z.object({
    showLogo: z.boolean(),
    showPlayerName: z.boolean(),
    showPlayerId: z.boolean(),
    isSticky: z.boolean(),
    backgroundOpacity: z
      .number()
      .min(0, { message: 'Opacity must be at least 0%' })
      .max(100, { message: 'Opacity must be at most 100%' }),
    textColor: gradientSchema
  }),
  banner: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  promotion: z.object({
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  bundle: z.object({
    offersPerRow: z.nativeEnum(ETemplateStudioBundlesViewModel).nullable(),
    bundleViewModel: z.nativeEnum(ETemplateStudioBundlesViewModel),
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  popup: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  rollingOffers: z.object({
    desktopLayout: z.nativeEnum(ETemplateStudioLayoutOptions),
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  progressBar: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  richText: z
    .object({
      text: z.string(),
      fontColor: z.string()
    })
    .optional(),
  dailyBonusBadge: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  footer: z.object({
    showAppchargeLogo: z.boolean(),
    backgroundOpacity: z.number().min(0).max(100),
    textColor: gradientSchema
  }),
  brandKit: z.object({
    fontFamily: z.string(),
    buttonColor: gradientSchema,
    buttonTextColor: z.string(),
    logo: z.string().min(1, { message: 'This field is required.' }),
    backgroundImageMobile: z
      .string()
      .min(1, { message: 'This field is required.' }),
    backgroundImageDesktop: z
      .string()
      .min(1, { message: 'This field is required.' }),
    defaultBanner: z.string(),
    footerDesktopImage: z.string(),
    footerMobileImage: z.string()
  }),
  externalButtons: z.object({
    verticalOffset: z.number().min(0).max(100),
    addToHomeScreenButton: z
      .object({
        active: z.boolean(),
        borderColor: gradientSchema,
        backgroundColor: gradientSchema,
        buttonImage: z.string().optional(),
        iconImage: z.string().optional(),
        shortcutName: z.string().optional()
      })
      .refine(
        (data) => !data.active || (data.iconImage?.trim().length ?? 0) > 0,
        { message: 'This field is required.', path: ['iconImage'] }
      )
      .refine(
        (data) => !data.active || (data.shortcutName?.trim().length ?? 0) > 0,
        { message: 'This field is required.', path: ['shortcutName'] }
      ),
    backToGameButton: z
      .object({
        active: z.boolean(),
        buttonImage: z.string().optional(),
        position: z.nativeEnum(EPosition)
      })
      .refine(
        (data) => !data.active || (data.buttonImage?.trim().length ?? 0) > 0,
        { message: 'This field is required.', path: ['iconImage'] }
      )
  })
});
